export default "__VITE_ASSET__Csef66ej__"